// Route access decision for protected pages (e.g. /queue). Pure: decide only once every async layer has
// reported — the lazily loaded wallet shell (walletReady), the adapter→context sync (isWalletPending),
// the server auth session and the subscription fetch. Deciding earlier redirected a subscribed merchant
// who reloaded /queue to Home (the default context looks "logged out").

export type RouteAccess = 'allow' | 'loading' | 'redirect' | 'gate';

export type RouteAccessInput = Readonly<{
  readonly requireAuth: boolean;
  readonly requiredFeature: string | undefined;
  readonly walletReady: boolean;          // wallet provider loaded (PersistentWallet lazy-loads it)
  readonly isReconnecting: boolean;       // adapter restoring a previous connection
  readonly isWalletPending: boolean;      // adapter connected, context not synced yet
  readonly hasWallet: boolean;            // context has a connected wallet
  readonly authActive: boolean;
  readonly hasSession: boolean;           // server auth session id received
  readonly subscriptionKnown: boolean;    // subscription status fetched (or failed)
  readonly hasFeature: boolean;
}>;

export const decideRouteAccess = (i: RouteAccessInput): RouteAccess => {
  if (i.requireAuth) {
    if (!i.walletReady || i.isReconnecting || i.isWalletPending) return 'loading';
    if (!i.hasWallet || !i.authActive) return 'redirect';
  }
  if (i.requiredFeature !== undefined) {
    if (!i.hasSession || !i.subscriptionKnown) return 'loading';
    if (!i.hasFeature) return 'gate';
  }
  return 'allow';
};
